import React from 'react';
import BlogCard from './BlogCard';
import '../styles/Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      id: 'mer-attribution',
      title: 'The Death of Last-Click Attribution: Why MER is the Future',
      excerpt: 'Traditional attribution models are failing marketers. Learn how Marketing Efficiency Ratio (MER) provides a clearer picture of campaign performance and why it matters for scaling.',
      date: 'March 15, 2025',
      readTime: '8 min read',
      category: 'Analytics',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80'
    },
    {
      id: 'ai-personalization',
      title: 'AI-Powered Personalization: Beyond Basic Segmentation',
      excerpt: 'Discover how predictive AI and machine learning are revolutionizing customer segmentation and automated personalization to drive exponential ROI in competitive markets.',
      date: 'March 8, 2025',
      readTime: '10 min read',
      category: 'AI Integration',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80'
    },
    {
      id: 'server-side-tracking',
      title: 'Server-Side Tracking: The Solution to iOS 14.5+ Tracking Loss',
      excerpt: 'Apple\'s privacy changes disrupted digital marketing. Here\'s how server-side tracking with GTM and GA4 can recover lost data and improve attribution accuracy.',
      date: 'February 28, 2025',
      readTime: '12 min read',
      category: 'Technical Marketing',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80'
    },
    {
      id: 'funnel-leakage',
      title: 'Funnel Leakage: The Silent Budget Killer',
      excerpt: 'Most marketing budgets bleed out between click and conversion. Learn the technical infrastructure changes that stop funnel leakage and maximize ROI.',
      date: 'February 20, 2025',
      readTime: '7 min read',
      category: 'CRO',
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80'
    }
  ];

  return (
    <section id="blog" className="blog">
      <div className="blog-container">
        <div className="blog-header reveal">
          <div className="section-label">Digital Marketing Insights</div>
          <h2 className="section-title">Growth Strategy Articles & Performance Marketing Insights</h2>
          <div className="title-underline"></div>
          <p className="blog-subtitle">
            Technical deep-dives on performance marketing, growth strategies, attribution, and AI-driven optimization.
          </p>
        </div>

        <div className="blog-grid">
          {blogPosts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
